import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import {defaultTheme} from '@ibibo/build-theme';
import IconSelector from '@ibibo/icon-selector';
import {appConfig} from '@ibibo/hotels-config';
import {reviewPagePaymentBreakupSelector} from '@ibibo/hotels-review-reducer';

import * as S from '../Wallet/Wallet.styles';

import PriceBlockLoader from '../../Loadingpage/ReviewPageLoaders/PriceBlockLoader/PriceBlockLoader';

const WalletBlock: React.FC<{loading: boolean;}> = ({
  loading
}) => {
  const {
    reviewPageTotalApplicablePGAmount,
    reviewPageTotalApplicableWalletAmount,
    reviewPageTotalWalletAmount
  } = useSelector(reviewPagePaymentBreakupSelector);

  const [open, setOpen] = useState(true);

  return (
    <S.WalletBlockWrapDiv>
      {(loading && <PriceBlockLoader />) || (
        <S.WalletBlockInnerWrapDiv>
          <S.PricingTxtWrapDiv>
            <S.PricingTxtSpan>PAYMENT</S.PricingTxtSpan>
            <S.CircularDiv onClick={() => setOpen(state => !state)}>
              <S.ArrowDownNewWrap transformstyle={(open && 'rotate(180deg)') || 'rotate(0deg)'} />
            </S.CircularDiv>
          </S.PricingTxtWrapDiv>

          <S.RoomChargesOuterWrapDiv display={!open && 'none'}>
            <S.RoomChargesWrapDiv>
            <S.ConviFeeWrapDiv fw={700}>
              <S.PricingNewWrapDiv>
                <S.ConvifeeTxtSpan fs="16">My Cash</S.ConvifeeTxtSpan>
                <S.BreakUpPriceWrapSpan fs="16">{reviewPageTotalApplicableWalletAmount ? '-' : ''} <IconSelector iconKey='rupee' props={{width:"1rem", height:'1rem', fill:defaultTheme.colors.black.base}} />{reviewPageTotalApplicableWalletAmount.toLocaleString('en-IN')}</S.BreakUpPriceWrapSpan>
              </S.PricingNewWrapDiv>
              <S.PricingNewWrapDiv>
                <S.ConvifeeTxtSpan fs="12" color={defaultTheme.colors.grey.light9b}>(Total Balance <IconSelector iconKey='rupee' props={{width:"0.8rem", height:'0.8rem', fill:defaultTheme.colors.grey.light9b}} />{reviewPageTotalWalletAmount.toLocaleString('en-IN')})</S.ConvifeeTxtSpan>
              </S.PricingNewWrapDiv>
            </S.ConviFeeWrapDiv>
            <S.ConviFeeWrapDiv fw={700}>
              <S.PricingNewWrapDiv>
                <S.ConvifeeTxtSpan fs="16">Balance Payment</S.ConvifeeTxtSpan>
                <S.BreakUpPriceWrapSpan fs="16"><IconSelector iconKey='rupee' props={{width:"1rem", height:'1rem', fill:defaultTheme.colors.black.base}} />{reviewPageTotalApplicablePGAmount.toLocaleString('en-IN')}</S.BreakUpPriceWrapSpan>
              </S.PricingNewWrapDiv>
            </S.ConviFeeWrapDiv>
            </S.RoomChargesWrapDiv>
          </S.RoomChargesOuterWrapDiv>
        </S.WalletBlockInnerWrapDiv>
      )}
    </S.WalletBlockWrapDiv>
  );
};

export default WalletBlock;
